import { ChevronRightOutline } from '@olist/design-system-icons';
import styled, { css } from 'styled-components';
import { ButtonIcon } from '../ButtonIcon/ButtonIcon.js';

const BreadcrumbContainer = styled.ul(({ theme }) => css `
    display: flex;
    align-items: center;
    list-style: none;
    color: ${theme.olist.color.primary.base};
  `);
const BreadcrumbItem = styled.li `
  display: flex;
  align-items: center;
`;
const StyledChevronRightOutline = styled(ChevronRightOutline)(({ theme }) => css `
    margin: 0 ${theme.olist.spacing.inline['3xsmall']};
  `);
const StyledButtonIcon = styled(ButtonIcon) ``;

export { BreadcrumbContainer, BreadcrumbItem, StyledButtonIcon, StyledChevronRightOutline };
